import React, { Component } from "react";

export default class LachakToranjTabToranjItem extends Component {
  render() {
    return (
      <li
        className={`${this.props.activePartsTab === "toranj" ? "active" : ""} ${
          this.props.themeDirection === "ltr" ? "item-EN" : ""
        }`}
        onClick={() => {
          this.props.partsTabHandler("toranj");
        }}
      >
        <svg width="100%" height="100%" viewBox="0 0 34 23" version="1.1">
          <g transform="matrix(1,0,0,1,-2608.39,-3003.85)">
            <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
              <g transform="matrix(0.0399722,0,8.11535e-34,0.04245,7510.63,132.851)">
                <rect
                  x="474.416"
                  y="391.142"
                  width="807.127"
                  height="506.676"
                  style={{
                    fill: "white",
                    strokeWidth: "24.25px",
                  }}
                />
              </g>
            </g>
            <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
              <g transform="matrix(0.177491,1.62307e-33,-8.11535e-34,0.0844435,7425.07,115.953)">
                <path
                  d="M748.418,523.966L679.77,604.45L611.121,523.966L679.77,443.482L748.418,523.966Z"
                  style={{
                    strokeWidth: "7.2px",
                  }}
                />
              </g>
            </g>
          </g>
        </svg>
        <span>{this.props.texts["toranj"]}</span>
      </li>
    );
  }
}
